import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const authToken = localStorage.getItem('authToken');
  return {
    'Authorization': authToken ? `Bearer ${authToken}` : ''
  };
};

const TVAController = {
  /**
   * Fetch TVA rates with pagination
   * @param {number} pageNumber - Current page number
   * @param {number} size - Items per page
   * @returns {Promise<Object>} - Paginated TVA data
   */
  fetchAllTva: async () => {
    try {
        const response = await axios.get(`${API_URL}/tva`, {
          headers: getAuthHeaders()
        });
        return response.data;
      } catch (error) {
        console.error('Error fetching TVA rates:', error);
        throw error;
      }
  }
};

export default TVAController;